import React from 'react';
import NumbersSection from '../components/NumbersSection';
import Highlights from '../components/Highlights';
import BlueSectionDivider from '../components/BlueSectionDivider';
import Offices from '../components/Offices';
import Footer from '../components/Footer';

const Contact=()=>{
    return (
        <div>
            <NumbersSection/>
            <Highlights/>
            <BlueSectionDivider/>
            <Offices/>
            <Footer/>

        </div>
    )
}
export default Contact;